import { format, isValid, parseISO } from 'date-fns';
import { uniq } from 'lodash';
import { IDatesValidation } from '~/services/api/clientAllocation';

type IDatesErrors = {
  errorDates: string[];
  showDifferentTeamErrorMessage: boolean;
};

const getTeamMemberDatesErrors = (
  teamMemberId: number,
  datesValidation?: IDatesValidation,
): IDatesErrors | null => {
  const errors: IDatesErrors = {
    errorDates: [],
    showDifferentTeamErrorMessage: false,
  };

  if (datesValidation) {
    errors.errorDates.push(
      ...uniq(
        datesValidation?.users
          .find(user => user.userId === teamMemberId)
          ?.unavailableDates.map(item => {
            const dateString = parseISO(item.split('T')[0]);

            if (dateString && isValid(dateString)) {
              return format(dateString, 'MM-dd-yyyy');
            }

            return null;
          })
          .filter(Boolean) || [],
      ),
    );

    errors.showDifferentTeamErrorMessage = !!datesValidation?.users.find(
      user => user.userId === teamMemberId && user.isDifferentTeam,
    );
  }

  return errors;
};

export default getTeamMemberDatesErrors;
